import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';
import { getTimePeriodIdString } from 'constants/helper';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

const getRealignViewDataApi = ({ timeBoundPeriod }) => {
  const url = endpoints.rabbitGoals.realignView;

  const { startTS, endTS, timelineTag } = timeBoundPeriod;
  return sendRequest({
    method: 'GET',
    url,
    queryParams: {
      startTS,
      endTS,
      timelineTag,
    },
    credentials: 'include',
  });
};
const goalsRealignViewReactQueryKey = ({ timeBoundPeriod }) => [
  REACT_QUERY_KEYS.GoalsRealignData,
  getTimePeriodIdString(timeBoundPeriod),
];

export const useOKRRealignViewData = ({ timeBoundPeriod }) =>
  useQuery(
    goalsRealignViewReactQueryKey({
      timeBoundPeriod,
    }),
    () =>
      getRealignViewDataApi({
        timeBoundPeriod,
      })
        .then((res) => res.entity)
        .catch((err) => {
          console.error(err);
          return err;
        }),
    { enabled: !!timeBoundPeriod }
  );
